import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FechamentoMarcacao } from '../../marcacao/fechamento-marcacao';

@Component({
  selector: 'app-informacao-fechamento-detail',
  templateUrl: './informacao-fechamento-detail.component.html',
  styleUrls: ['./informacao-fechamento-detail.component.css']
})
export class InformacaoFechamentoDetailComponent implements OnInit {

  fechamentoMarcacao: FechamentoMarcacao;

  formularioInformacaoFechamento: FormGroup;

  constructor(private router: Router,
    private formBuilder: FormBuilder) {

    this.fechamentoMarcacao = Object.assign(new FechamentoMarcacao(), history.state.fechamentoMarcacao);

    this.formularioInformacaoFechamento = this.formBuilder.group({
      idUserFechamento: '',
      loginUserFechamento: '',
      dataFechamento: '',
      dataFechamentoFormatada: '',
    });
  }

  ngOnInit() {

    this.configurarForm();
  }

  gotoList() {
    const paginaAnterior = history.state.paginaAnterior;

    this.router.navigate(['/' + paginaAnterior], {
        state: {
        filtroMarcacao: history.state.filtroMarcacao,
        textFilter: history.state.textFilter,
      }
    });
  }

  configurarForm(): void {

    this.fechamentoMarcacao.dataFechamentoFormatada = formatDate(this.fechamentoMarcacao.dataFechamento, 'dd/MM/yyyy HH:mm:ss', 'en');

    this.formularioInformacaoFechamento.setValue(this.fechamentoMarcacao);
    this.formularioInformacaoFechamento.disable();
  }

}
